<template>
  <date-range-picker
    ref="datepicker"
    v-bind="$attrs"
    :date-range="date"
    :ranges="ranges"
    :locale-data="localeData"
    auto-apply
    date-util="moment"
    v-on="$listeners"
    @update="update"
  />
</template>
<script>
import DateRangePicker from 'vue2-daterange-picker'

export default {
  components: {
    DateRangePicker,
  },
  props: {
    appendToBody: {
      type: Boolean,
      default: true,
    },
    value: {
      type: [Object, String],
      required: false,
    },
    ranges: {
      type: [Object, Boolean],
      default() {
        return {
          Dnes: [this.$moment().toDate(), this.$moment().toDate()],
          Včera: [
            this.$moment().subtract(1, 'days').toDate(),
            this.$moment().subtract(1, 'days').toDate(),
          ],
          'Predch. týždeň': [
            this.$moment().subtract(1, 'week').startOf('week').toDate(),
            this.$moment().subtract(1, 'week').endOf('week').toDate(),
          ],
          'Predch. mesiac': [
            this.$moment().subtract(1, 'month').startOf('month').toDate(),
            this.$moment().subtract(1, 'month').endOf('month').toDate(),
          ],
          'Tento mesiac': [
            this.$moment().startOf('month').toDate(),
            this.$moment().endOf('month').toDate(),
          ],
          'Tento rok': [
            this.$moment().startOf('year').toDate(),
            this.$moment().endOf('year').toDate(),
          ],
          'Predch. rok': [
            this.$moment().subtract(1, 'year').startOf('year').toDate(),
            this.$moment().subtract(1, 'year').endOf('year').toDate(),
          ],
        }
      },
    },
  },
  data() {
    return {
      date: {
        startDate: null,
        endDate: null,
      },
      localeData: {
        direction: 'ltr',
        format: 'dd.mm.yyyy',
        separator: ' - ',
        applyLabel: 'Použiť',
        cancelLabel: 'Zrušiť',
        weekLabel: 'W',
        customRangeLabel: 'Vlastný rozsah',
        daysOfWeek: this.$moment.localeData('sk').weekdaysMin(),
        monthNames: this.$moment.localeData('sk').monthsShort(),
        firstDay: 1,
      },
    }
  },
  watch: {
    value: {
      handler(newVal) {
        if (this.$attrs.hasOwnProperty('single-date-picker')) {
          this.date.startDate = newVal
            ? this.$moment(newVal, 'YYYY-MM-DD')
            : null
          this.date.endDate = newVal ? this.$moment(newVal, 'YYYY-MM-DD') : null
        } else {
          this.date.startDate = newVal.ge
            ? this.$moment(newVal.ge, 'YYYY-MM-DD')
            : null
          this.date.endDate = newVal.ge
            ? this.$moment(newVal.lt, 'YYYY-MM-DD')
            : null
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    update(dateRangeObj) {
      this.date = dateRangeObj

      if (this.$attrs.hasOwnProperty('single-date-picker')) {
        this.$emit(
          'input',
          this.$moment(this.date.startDate, 'YYYY-MM-DD').format('YYYY-MM-DD'),
        )
      } else {
        this.$emit('input', {
          ge: this.$moment(this.date.startDate, 'YYYY-MM-DD').format(
            'YYYY-MM-DD',
          ),
          lt: this.$moment(this.date.endDate, 'YYYY-MM-DD').format(
            'YYYY-MM-DD',
          ),
        })
      }
    },
  },
}
</script>
